<template>
    <div class="bg-white rounded-md shadow-sm border border-gray-200 mt-6">
        <!-- Header Section -->
        <div class="sm:col-span-6 flex justify-between items-center border-b border-gray-200 py-4 px-6">
            <div>
                <h4 class="text-xl font-bold text-gray-700 sm:text-2xl">RentRisk User Acknowledgment Statement</h4>
                <p class="text-sm text-gray-500 mt-1">Sign up for our newsletters and market updates</p>
            </div>
        </div>
        
        <!-- Content Section -->
        <div class="p-6">
            <div class="bg-gray-50 rounded-lg p-4 mb-4">
                <p class="text-sm text-gray-700 leading-relaxed">
                    As a valued user of RentRisk's tenant screening services, we are committed to providing you with not only accurate tenant screening solutions but also valuable insights and information related to the rental market and industry trends. We believe in keeping you informed and empowered. By checking the box below, you acknowledge your interest in receiving additional rental market information, industry trends, emails, and our newsletter featuring content and discussions relevant to the real estate and rental industry.
                </p>
            </div>
            
            <label class="flex items-start space-x-3 my-4">
                <input 
                    v-model="form.newsletter" 
                    type="checkbox" 
                    class="mt-1 rounded border-gray-300 text-rent-risk-blue-400 focus:ring-rent-risk-blue-400 h-4 w-4" 
                />
                <span class="text-sm font-medium text-gray-700">
                    Yes, I am interested in receiving additional rental market information, industry trends, emails, and the RentRisk newsletter.
                </span>
            </label>
            
            <p class="text-sm text-gray-600 leading-relaxed">
                Your trust is important to us, and we will always respect your preferences and privacy. You can unsubscribe at any time from these communications by following the instructions in the emails we send. Thank you for choosing RentRisk. We look forward to keeping you informed and engaged with the latest developments in the real estate and rental market.
            </p>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        form: Object,
        application: Object,
        states: Object,
        validateField: Function,
    },
}
</script>